export const IMPORTING_GL_ACCOUNT_LIST = 'IMPORTING_GL_ACCOUNT_LIST';
export const IMPORTING_GL_ACCOUNT_LIST_SUCCESS = 'IMPORTING_GL_ACCOUNT_LIST_SUCCESS';
export const IMPORTING_GL_ACCOUNT_LIST_FAILURE = 'IMPORTING_GL_ACCOUNT_LIST_FAILURE';

export const FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST = 'FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST';
export const FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_SUCCESS = 'FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_SUCCESS';
export const FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_FAILURE = 'FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_FAILURE';

export const FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL = 'FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL';
export const FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL_FINISHED = 'FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL_FINISHED';
